'use client'
import { Button } from "@/components/ui/button"
import { useFormStatus } from 'react-dom'
 
export default function SearchButton() {
  const status = useFormStatus()
  return (
    <Button type="submit">{status.pending ? 'Buscando...' : 'Buscar'}</Button>
  )
}